import { render, staticRenderFns } from "./slides-item.vue?vue&type=template&id=c5031c8c&scoped=true&"
import script from "./slides-item.vue?vue&type=script&lang=js&"
export * from "./slides-item.vue?vue&type=script&lang=js&"
import style0 from "./slides-item.vue?vue&type=style&index=0&id=c5031c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5031c8c",
  null
  
)

component.options.__file = "slides-item.vue"
export default component.exports